import React, { CSSProperties } from 'react'

// Styles
import './styles.scss'

// Icons
import IconLoading from './images/iconLoading'

export default ({
  color,
  width,
  height,
  style,
}: {
  color?: string
  width?: number
  height?: number
  style?: CSSProperties
}) => {
  return (
    <div className={'loading'} style={style}>
      <IconLoading color={color} width={width} height={height} />
    </div>
  )
}
